require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-redux-handle-an-action-in-the-store.json") })
        }
      }, "path---front-end-libraries-redux-handle-an-action-in-the-store");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-redux-handle-an-action-in-the-store!./.cache/json/front-end-libraries-redux-handle-an-action-in-the-store.json
// module id = 2118
// module chunks = 231608221292675